export default __webpack_public_path__ + "media/a0992e307bd3ffed29fb8aad08123a9e43548c564172d9604c97b9cd9df974ae.svg";